import { render, staticRenderFns } from "./ContactDetailView.vue?vue&type=template&id=1708919a"
import script from "./ContactDetailView.vue?vue&type=script&lang=js"
export * from "./ContactDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports